import styled, { css } from 'styled-components';
import { SECONDARY_COLOR, SECONDARY_COLOR_2 } from '../../const/color';
import { FAMILY_FONT_CONTROL } from '../../const/text';
import {device} from "../../const/device";

export const Icon = styled.div<{ open: boolean, themeColor: string }>`
  position: relative;
  display: inline-block;
  width: 20px;
  height: 14px;
  z-index: 200;
  margin-left: auto;
  top: 11px;
  outline: none;

  div {
    position: absolute;
    width: 20px;
    height: 2px;
    transition-property: transform;
    border-radius: 4px;
    background-color: ${props => props.themeColor == "black"?(props => props.open ? '#000000' : SECONDARY_COLOR_2):(props => props.open ? '#000000' : '#000000')};

    ${props => props.open ? css`
      transition-delay: .12s;
      transition-timing-function: cubic-bezier(.215,.61,.355,1);
      transform: rotate(45deg);
    ` : css`
      transition-timing-function: cubic-bezier(.55,.055,.675,.19);
      transition-duration: 75ms;
    `}
    

    &:before {
      content: '';
      display: block;
      position: absolute;
      width: 20px;
      height: 2px;
      transition-timing-function: ease;
      transition-duration: .15s;
      transition-property: transform;
      border-radius: 4px;
      background-color: ${props => props.themeColor == "black"?(props => props.open ? '#000000' : SECONDARY_COLOR_2):(props => props.open ? '#000000' : '#000000')};

      transition: top 75ms ease,opacity 75ms ease .12s;
      top: ${props => props.open ? 0 : -6}px;
      opacity: ${props => props.open ? 0 : 1};
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 20px;
      height: 2px;
      transition-timing-function: ease;
      transition-duration: .15s;
      transition-property: transform;
      border-radius: 4px;
      background-color: ${props => props.themeColor == "black"?(props => props.open ? '#000000' : SECONDARY_COLOR_2):(props => props.open ? '#000000' : '#000000')};

      bottom: ${props => props.open ? 0 : -6}px;
      transition: ${props => props.open ? 'bottom 75ms ease,transform 75ms cubic-bezier(.215,.61,.355,1) .12s' : 'bottom 75ms ease .12s,transform 75ms cubic-bezier(.55,.055,.675,.19)'};
      transform: rotate(${props => props.open ? -90 : 0}deg);
    }
  }
`;

export const Menu = styled.div<{ open: boolean }>`
  display: flex;
  flex-direction: column;
  transform: ${props => props.open ? 'translateX(0)' : 'translateX(100%)'};
  height: 100vh;
  text-align: left;
  position: fixed;
  top: 0;
  right: 0;
  transition: transform 0.3s ease-in-out;
  width: ${100 / 4.5}vw;
  background: white;
  z-index: 10;
  padding: 24px 16px;
  a {
    font-size: 16px;
    line-height: 160%;
    padding-left: 32px;
    margin-top: 16px;
    color: black;
    text-decoration: none;
    font-family: ${FAMILY_FONT_CONTROL};
  }
  
  @media(${device.tabletM}){
    width: ${100 / 3}vw;
  }
  
  @media(${device.mobileL}){
    width: ${100 / 2.5}vw;
  }
  
  @media(${device.mobileM}){
    width: ${100 / 2.3}vw;
  }
`;

export const LinkList = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Layout = styled.div<{ open: boolean }>`
  position: fixed;
  opacity: ${props => props.open ? 0.2 : 0};
  transition: opacity 0.3s linear;
  pointer-events: ${props => props.open ? 'auto' : 'none'};
  background-color: ${SECONDARY_COLOR};
  margin: -16px -32px;

  width: 100vw;
  height: 100vh;
  z-index: 9;
`;